// extracted by mini-css-extract-plugin
export var active = "_n-8";
export var addWidgetButton = "_n-9";
export var backButton = "_n-1";
export var pageContainer = "_n-2";
export var settingsContent = "_n-0";
export var sideNavContainer = "_n-6";
export var sideNavLink = "_n-7";
export var widgetContainer = "_n-5";
export var widgetSubsectionItem = "_n-3";
export var widgetSubsectionItemContent = "_n-4";